import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { marketWorkingLabel } from "@components/Common/Constant";

/**
 * MarketWorking Component
 * Displays market working statistics with insights and queries data
 * Refactored with Tailwind CSS
 * 
 * @component
 */
const MarketWorking = () => {
  const navigate = useNavigate();

  const marketWorkingCount = useSelector(
    (state) => state?.marketWorking?.marketWorkingDetails
  );

  // Handle click on count/number
  const onClickCountHandler = (item) => {
    if (item === "InsightToday" || item === "InsightMonth") {
      navigate("/my-diary");
    } else if (item?.heading === "Insight") {
      navigate("/my-diary");
    } else {
      navigate("/queries");
    }
  };

  return (
    <div className="w-[94%] mx-2 my-2 mb-6 h-32 bg-white rounded-xl shadow-[0.056rem_0.056rem_0.241rem_rgba(20,20,20,0.07)]">
      {/* Header */}
      <div className="w-full h-[2.125rem] bg-[#3901FF] rounded-t-xl flex items-center justify-between px-5">
        <div className="text-white font-semibold text-[0.688rem] leading-8">
          Market Working
        </div>
        <div className="flex items-center text-white font-medium text-[0.625rem] leading-8">
          <span className="w-2 h-2 rounded-full bg-[#73E8A3] mr-3"></span>
          <span>Today's Visit Planned</span>
        </div>
      </div>

      {/* Data Grid */}
      <div className="pt-3">
        <div className="grid grid-cols-4 text-center gap-2 px-2">
          {/* Numbers */}
          {marketWorkingCount &&
            Object.keys(marketWorkingCount).map((item) => {
              return marketWorkingCount[item]?.map((itemm, index) => (
                <div
                  key={`${item}-${index}`}
                  onClick={() => onClickCountHandler(item)}
                  className="text-[#3901FF] font-extrabold text-[1.227rem] -mb-1 cursor-pointer"
                >
                  {itemm.expr0}
                </div>
              ));
            })}

          {/* Labels */}
          {marketWorkingLabel?.map((items, index) => (
            <div
              key={index}
              onClick={() => onClickCountHandler(items)}
              className="cursor-pointer"
            >
              <div className="text-[#3901FF] font-bold text-[0.738rem] max-[370px]:text-[0.61rem] text-center">
                {items.heading}
              </div>
              <div className="text-[#595959] font-medium text-[0.488rem] whitespace-nowrap px-1">
                {items.heading_second}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketWorking;
